import { client } from "./supabase";

// Lista de clientes activos para selectors. Sin side effects (no toasts, no throws en data vacía).
// La tabla clientes usa "eliminada" como soft-delete (no tiene columna "habilitado").
export const getClientesActivos = async (pais) => {
  const { data, error } = await client
    .from("clientes")
    .select("id, empresa, nombre, rut")
    .eq("pais", pais)
    .eq("eliminada", false)
    .order("empresa", { ascending: true });
  if (error) throw error;
  return data || [];
};

// Crear cliente con campos mínimos desde el selector inline del modal de vinculación SII.
// A diferencia de saveCliente (que sincroniza contactos relacionales), este insert es plano:
// solo nombre, empresa, rut, pais. eliminada se setea explícitamente a false.
export const crearClienteMinimal = async ({ pais, empresa, nombre, rut }) => {
  const { data, error } = await client
    .from("clientes")
    .insert({ pais, empresa, nombre: nombre || empresa, rut: rut || null, eliminada: false })
    .select()
    .single();
  if (error) throw error;
  return data;
};
